export default __webpack_public_path__ + "static/media/thumb_manager.3271571b.jpg";